import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M78.0604 43.5208C78.0604 43.5208 60.2304 34.2108 56.1804 29.4708C51.6804 24.2108 51.8804 1.5708 51.8804 1.5708H39.4604C39.4604 1.5708 39.7704 24.3208 35.1604 29.4708C30.2704 34.9308 13.1104 43.1808 13.1104 43.1808C19.3004 57.7608 36.1303 68.4608 45.6703 68.4608C55.2003 68.4708 71.8604 58.1008 78.0604 43.5208Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M89.1504 71.7708C89.1604 71.7708 89.1604 71.7708 89.1504 71.7708V71.7708Z"
        fill="#F2F2F2"
        stroke="#D3D3D3"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 58.8408C85.51 47.5908 82.03 44.5208 77.36 42.3108C77.36 42.3108 67.76 53.7908 49.37 55.2308L45.58 64.5108L41.79 55.2308C23.4 53.8008 13.8 42.3108 13.8 42.3108C9.12999 44.5108 5.62998 47.9308 3.91998 58.8408C2.25998 69.4408 2 71.7708 2 71.7708H89.15C89.15 71.7708 88.86 69.3908 87.24 58.8408Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5813"
          y1="29.8874"
          x2="45.5813"
          y2="10.4637"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
